import { Button, Col, Row } from "antd";
import { useRef, useState, useEffect } from "react";
import Draggable from "react-draggable";
import { FaVideo } from "react-icons/fa";
import { MdCall, MdCallEnd } from "react-icons/md";
import callingMusic from "../../../assets/waiting-music.mp3";
import { useAuthLayoutContext } from "../../../context/AuthLayoutContext";
import { useInfoUser } from "../../../store/UserStore";
import "./style.scss";
import { CustomAvatar } from "../../../components/avatar/CustomAvatar";
import apiFactory from "../../../api";
import { openNotificationWarn } from "../../../utils/Utils";

const CURRENT_WEB =
  process.env.REACT_APP_CURRENT_WEB || "https://winitech.com.vn:3007";

const SmallInComingCall = () => {
  const { user, languageMap } = useInfoUser();
  const { call, setCall, checkDevices, openCallingWindow } =
    useAuthLayoutContext();
  const [isLoading, setIsLoading] = useState(false);
  const timeoutRef = useRef();

  const reject = async () => {
    clearTimer();
    await apiFactory.callingApi.reject({
      roomId: call?.roomId,
      userId: user?.userId,
      callingStatus: "REJECTED",
    });
    setCall(null);
  };

  const startTimer = () => {
    clearTimeout(timeoutRef.current);

    timeoutRef.current = setTimeout(async () => {
      clearTimer();
      setCall(null);
    }, 87_000);
  };

  const clearTimer = () => {
    if (timeoutRef?.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  const listenCall = async (mode) => {
    if (!(await checkDevices(mode))) {
      if (mode === "audio") openNotificationWarn("Your pc missed mic");

      if (mode === "video") openNotificationWarn("Your pc missed camera");

      return;
    }

    clearTimer();

    openCallingWindow(
      CURRENT_WEB + "/calling?room_id=" + call?.roomId + "&mode=" + mode,
    );
    setCall(null);
  };

  useEffect(() => {
    if (!user?.userId || !call?.roomId) return;

    startTimer();

    return clearTimer;
  }, [user?.userId, call?.roomId]);

  return (
    <Draggable bounds="parent" cancel=".ant-btn">
      <div className="absolute bottom-[100px] right-[50px] bg-[#2a56b9] text-white rounded-[10px] cursor-grabbing z-[99999] shadow-lg">
        <audio src={callingMusic} preload="auto" autoPlay loop />

        <Row className="pt-[10px] w-[100%]">
          <Col span={3}></Col>
          <Col span={18} className="text-[16px] font-semibold text-center">
            {languageMap?.["call.incoming"] ?? "Incoming call"}
          </Col>
          <Col span={3} className="flex justify-end pr-[20px]"></Col>
        </Row>
        <div className="general-modal pb-[10px] px-[70px]">
          <div className="flex flex-col items-center justify-between">
            <CustomAvatar
              person={{
                ...call?.announcer,
                name: call?.announcer?.userName,
              }}
              userId={call?.announcer?.userId}
              pos={-1}
              styleCss={{}}
              isShowUserStatus={{ status: false, isAlwaysTrue: false }}
              size={80}
            />
            <div className="text-[18px] font-bold mt-[10px]">
              {call?.announcer?.userName}
            </div>
            <div className="text-[16px] font-semibold">
              {languageMap?.["call.incoming"] ?? "is calling to you"}
            </div>

            <div className="flex gap-[50px] mt-[30px]">
              <Button
                type="default"
                shape="circle"
                className="bg-[#37b361] text-[white]"
                size="large"
                icon={<FaVideo className="text-[22px]" />}
                onClick={() => listenCall("video")}
              />
              <Button
                type="default"
                shape="circle"
                className="bg-[#37b361] text-[white] shake-up-down"
                size="large"
                icon={<MdCall className="text-[22px]" />}
                onClick={() => listenCall("audio")}
              />
              <Button
                type="default"
                shape="circle"
                className="bg-[red] text-[white]"
                size="large"
                icon={<MdCallEnd className="text-[22px]" />}
                onClick={reject}
              />
            </div>
          </div>
        </div>
      </div>
    </Draggable>
  );
};

export default SmallInComingCall;
